import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryCreatePageRoutingModule } from './gallery-create-routing.module';
import { GalleryCreatePage } from './gallery-create.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { HeaderPageTitleBoxComponent } from '@components/headers/page-title-box/page-title-box.component';
import { PlaceholderCardFormVerticalComponent } from '@components/placeholders/card-form-vertical/card-form-vertical.component';
import { InputTextModule } from 'primeng/inputtext';
import { PreviewUploadImageComponent } from '@components/preview-upload-image/preview-upload-image.component';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [
    GalleryCreatePage
  ],
  imports: [
    CommonModule,
    GalleryCreatePageRoutingModule,
    ReactiveFormsModule,
    RouterModule,
    BackboneComponent,
    HeaderPageTitleBoxComponent,
    PlaceholderCardFormVerticalComponent,
    InputTextModule,
    PreviewUploadImageComponent,
    ButtonModule
  ]
})
export class GalleryCreatePageModule { }
